/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of all the linked lists available for @see {@link Synqo.Cloud.Model.Api.Permissions.ApiUser}
 */
export class ExternalApplicationLinkLists {
    /**
     * Represents a list of linked groups
     */
    static readonly groups: string = 'groups';
}
